import request from '@/utils/request';

// const requestInstance = request();

const userInfoRequest = request();
userInfoRequest.interceptors.request.use(
  (config) => {
    config.baseURL = process.env.VUE_APP_GRAPH_URL;
    return config;
  },
);

// 用户个人中心
const userCenterRequest = request();
userCenterRequest.interceptors.request.use(
  (config) => {
    config.baseURL = process.env.VUE_APP_3VJIA_DOMAIN_NAME;
    return config;
  },
);

/**
 * 获取当前登录用户信息
 */
export function getCurrentUser() {
  return userInfoRequest.get('/getUserInfo');
}


/**
 * 获取当前登录用户权限
 */
// export function getAuthorty() {
//   return requestInstance.get('/getAuthorty');
// }

/**
 * 根据ID获取用户信息
 */
// export function getUserById() {
//   return requestInstance.get(`/user/detail/${id}`);
// }

// 获取未读消息
export function getUnreadMsg(prm) {
  return userCenterRequest.post('/pcenter/usermsg/getDesignMsgListByUserId', prm);
}
